import PropTypes from "prop-types";
import React from "react";
import BaseComponent from "../BaseComponent";
import Callback from "../../../appl/model/system/Callback";

/**
 * events: onTabClick
 */
class TabBarBase extends BaseComponent {

  static CMD_CHANGE = 'cmd_change';
  static CMD_REMOVE = 'cmd_remove';

  constructor(props) {
    super(props);
    this.state = {
      tabs: [], activeTabId: 0, tabNumSequence: 0, tabListeners: new Callback(), identifications: {}
    };
  }

  onTabClick(id) {
    this.state.activeTabId = id;
    this.setState(this.state);
    this.private_doFireListeners(id, TabBarBase.CMD_CHANGE);
  }

  setActiveTab(id) {
    this.onTabClick(id);
  }

  /**
   * @param tab -> tab muss folgende Schnittstelle aufweisen => id, activeTabId, onTabClick, onRemoveClick
   * @param tabContent -> content kann folgende Schnittstelle implementieren => id, activeTabId, onRemoveClick
   * @param identification
   */
  addTab = (tab, tabContent, identification) => {
    let tabId = undefined;
    if (identification === undefined || !this.state.identifications[identification]) {
      this.state.tabs.push({id: this.state.tabNumSequence, tab: tab, tabContent: tabContent});
      this.state.activeTabId = this.state.tabNumSequence;
      tabId = this.state.tabNumSequence;
      if (!identification) {
        identification = tabId;
      }
      this.state.identifications[identification] = tabId;
      this.state.tabNumSequence++;
      this.setState(this.state);
    } else {
      tabId = this.state.identifications[identification];
      this.setActiveTab(this.state.identifications[identification]);
    }
    return tabId
  };

  addTabListener(tabListener) {
    if (tabListener) {
      this.state.tabListeners.addListener(tabListener);
    }
  }

  onRemoveClick = (id) => {
    this.removeTab(id);
  };

  removeTab = (id) => {
    let key = Object.keys(this.state.identifications)[Object.values(this.state.identifications).indexOf(id)];
    if (key) {
      delete this.state.identifications[key];
    }
    this.selectNextActiveTab(id);
    this.state.tabs = this.state.tabs.filter((tab) => tab.id !== id);
    this.setState(this.state);
    this.private_doFireListeners(this.state.activeTabId, TabBarBase.CMD_REMOVE);
    this.state.tabListeners.listeners = this.state.tabListeners.listeners.filter((tabListener) => tabListener.id !== id);
  }

  private_doFireListeners(id, tabBarCmd) {
    this.state.tabListeners.fire(id, tabBarCmd);

    this.state.tabs.map((tab) => {
      if (tab.tabContent.ref && typeof tab.tabContent.ref.current.onTabClick === 'function') {
        tab.tabContent.ref.current.onTabClick(id, tabBarCmd);
      }
    });
  }

  selectNextActiveTab(idToRemove) {
    if (this.state.activeTabId === idToRemove) {
      let nextIndex = this.state.tabs.findIndex((tab) => tab.id === idToRemove) + 1;
      if (nextIndex > this.state.tabs.length - 1) {
        nextIndex = this.state.tabs.length - 2;
      }
      if (nextIndex < 0) {
        nextIndex = 0;
      }
      this.state.activeTabId = this.state.tabs[nextIndex].id;
    }
  }

  getArrayTabIndex(activeTabId) {
    return this.state.tabs.findIndex((tab) => tab.id === activeTabId);
  }

  render() {
    return <div>hier muss überschrieben werden</div>;
  }
}

TabBarBase.propTypes = {
  className: PropTypes.string
};
export default TabBarBase;
